const LOCALE = 'en-US'

export function formatCurrency(
  value: number | string | undefined,
  decimalPlaces: number,
  currency = 'USD',
): string {
  const parsedValue = typeof value === 'string' ? parseFloat(value) : value

  if (typeof parsedValue === 'undefined' || isNaN(parsedValue)) {
    throw new Error('Invalid value for currency formatting')
  }

  return parsedValue.toLocaleString(LOCALE, {
    style: 'currency',
    currency,
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })
}
